import request from './axios';

/**
 * 获取企业统计概览数据
 * @returns {Promise<Object>} 返回统计数据
 */
export function getOverview() {
  return request({
    url: '/webapi/statistics/overview',
    method: 'get'
  });
} 